<template>
  <div class="m-link-to-fill-questionnaire">
    <b-modal
      id="referrals-link-to-fill-questionnaire-modal"
      v-model="localActive"
      size="custom-size"
      centered
      hide-footer
      hide-header
      @show="onShowModal"
      @close="localActive = false"
    >
      <svg
        class="m-link-to-fill-questionnaire-close"
        width="15"
        height="16"
        viewBox="0 0 15 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        @click="localActive = false"
      >
        <path
          d="M10.6045 11.5377C10.2154 11.9267 9.58272 11.9247 9.19126 11.5333L3.53712 5.88051C3.14565 5.48904 3.14367 4.85633 3.5327 4.4673C3.92172 4.07828 4.55443 4.08026 4.9459 4.47173L10.6 10.1245C10.9915 10.5159 10.9935 11.1486 10.6045 11.5377Z"
          fill="#8E9CBB"
        />
        <path
          d="M10.6127 4.47053C10.2212 4.07907 9.58849 4.07709 9.19947 4.46611L3.53718 10.1284C3.14816 10.5174 3.15014 11.1501 3.54161 11.5416C3.93307 11.9331 4.56579 11.9351 4.95481 11.546L10.6171 5.88374C11.0061 5.49471 11.0041 4.862 10.6127 4.47053Z"
          fill="#8E9CBB"
        />
      </svg>
      <div class="m-link-to-fill-questionnaire-title">Ссылка на заполнение анкеты</div>
      <c-input
        v-model="postLocalValue"
        class="m-link-to-fill-questionnaire-post"
        type="select"
        label="Должность"
        :searchable="true"
        placeholder="Выберите должность"
        :items="postLocalItems"
      />
      <c-input
        v-if="postLocalValue !== null"
        v-model="postLocalValue.link"
        class="m-link-to-fill-questionnaire-link"
        :editable="false"
        :copied-to-clipboard="true"
        type="text"
        label="Ссылка"
        @copyToClipboard="showSuccessMessageCopyClipboard"
      />
      <div
        :class="{ 'm-link-to-fill-questionnaire-copy-message-active': isShowSuccessMessageCopyToClipboard }"
        class="m-link-to-fill-questionnaire-copy-message"
      >
        <svg width="14" height="10" viewBox="0 0 14 10" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M4.47288 9.68401C4.08236 9.29348 4.08236 8.66032 4.47288 8.2698L12.2929 0.449632C12.6835 0.0591074 13.3166 0.059107 13.7072 0.449631C14.0977 0.840156 14.0977 1.47332 13.7072 1.86384L5.8871 9.68401C5.49657 10.0745 4.86341 10.0745 4.47288 9.68401Z"
            fill="#12C971"
          />
          <path
            d="M5.8871 9.68401C6.27762 9.29348 6.27756 8.66032 5.88704 8.2698L1.70711 4.08989C1.31658 3.69937 0.683417 3.69937 0.292893 4.08989C-0.097631 4.48042 -0.0976311 5.11358 0.292893 5.50411L4.47288 9.68401C4.86341 10.0745 5.49657 10.0745 5.8871 9.68401Z"
            fill="#12C971"
          />
        </svg>
        <div class="m-link-to-fill-questionnaire-copy-message-text">Ссылка скопирована в буфер обмена</div>
      </div>
      <c-button class="m-link-to-fill-questionnaire-button-close" label="Закрыть" @click="closeModal" />
    </b-modal>
  </div>
</template>

<script>
import Input from "@/components/controls2/Input";
import Button from "@/components/controls2/Button";

export default {
  name: "referrals-link-to-fill-questionnaire-modal",
  components: {
    "c-input": Input,
    "c-button": Button,
  },
  props: ["active"],
  data() {
    return {
      localActive: false,
      postLocalItems: [],
      postLocalValue: null,
      isShowSuccessMessageCopyToClipboard: false,
    };
  },

  watch: {
    localActive(value) {
      if (!value) {
        this.$emit("close");
      }
    },
    active(value) {
      this.localActive = value;
    },
  },

  mounted() {},

  methods: {
    onShowModal() {
      this.$store.dispatch("personalEmployee/getPostList").then((res) => {
        this.postLocalItems = [];
        const { host } = window.location;
        const workerId = this.$route.params.id;

        this.postLocalItems = res.response.map((item) => ({
          label: item.name,
          value: item.id,
          // link: `${host}/index.php?r=worksheet%2Fnew&code=${item.id}&invited_by_worker=${workerId}`,
          link: `${host}/redesign/profile.html?position=${item.id}&inviter=${workerId}`,
        }));

        const [firstPost] = this.postLocalItems;
        this.postLocalValue = firstPost;
      });
    },
    closeModal() {
      this.localActive = false;
      setTimeout(() => {
        this.isShowSuccessMessageCopyToClipboard = false;
      }, 250);
    },
    showSuccessMessageCopyClipboard() {
      this.isShowSuccessMessageCopyToClipboard = true;
      setTimeout(() => {
        this.isShowSuccessMessageCopyToClipboard = false;
      }, 3000);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.m-link-to-fill-questionnaire {
  position: relative;

  &-close {
    cursor: pointer;
    position: absolute;
    top: 12px;
    right: 10px;
  }

  &-title {
    font-weight: 500;
    font-size: 18px;
    line-height: 120%;

    @media screen and (max-width: 700px) {
      font-size: 15px;
      line-height: 120%;
    }
  }

  &-post {
    margin-top: 18px;

    @media screen and (max-width: 700px) {
      margin-top: 26px;
    }
  }

  &-link {
    margin-top: 27px;
  }

  &-copy-message {
    display: flex;
    align-items: center;
    margin-top: 17px;
    max-height: 0;
    opacity: 0;
    transition: 0.2s;

    &-text {
      margin-left: 11.5px;
      font-size: 13px;
      line-height: 120%;
      color: #12c971;
    }

    &-active {
      opacity: 1;
      max-height: 100%;
    }
  }

  &-button-close {
    margin: 20px 0 0 auto;
    max-width: 110px;
    background: #ffffff;

    @media screen and (max-width: 700px) {
      max-width: calc(100% + 40px);
      width: calc(100% + 40px);
      margin: 28px 0 -28px -20px;
      border-radius: 0;
      border-bottom: none;
      border-left: none;
      border-right: none;
    }
  }
}
</style>
